import { observer } from 'mobx-react';
import React, { Component } from 'react';
import { cartStore } from 'src/mobx/cartStore';
import { IProduct } from 'src/types/products';
import CartProduct from '../CartProduct/CartProduct';
import './style.scss';

@observer
export default class CartProducts extends Component<{}, {}> {
  renderCartProduct = (product: IProduct, index: number) => {
    return <CartProduct key={product.hash} product={product} index={index} />;
  };

  render() {
    return (
      <section className={'cart-section border-tr-0 d-flex flex-column pt-3 pb-0 mb-1'}>
        {cartStore.products.map(this.renderCartProduct)}
      </section>
    );
  }
}
